import { select, Selection } from "d3-selection";

export class ChartTooltip {
    private _currentContext: JQuery<HTMLElement> = null;
    private _tooltip: Selection<HTMLDivElement, unknown, null, unknown>;

    public constructor(
        currentContext: JQuery<HTMLElement>
    ) {
        this._currentContext = currentContext || this._currentContext;

        this.createTooltip();
        this.hide();
    }

    private createTooltip(): void {
        this._tooltip = select(this._currentContext.get(0))
            .append("div")
            .attr("class", "pcg-chart-tooltip");

        this._tooltip
            .append("div")
            .attr("class", "pcg-chart-tooltip__header");

        this._tooltip
            .append("div")
            .attr("class", "pcg-chart-tooltip__text");
    }

    public show(header: string, text: string): void {
        this._tooltip
            .select(".pcg-chart-tooltip__header")
            .text(header);

        this._tooltip
            .select(".pcg-chart-tooltip__text")
            .text(text);

        this._tooltip
            .style("display", "block");
    }

    public hide(): void {
        this._tooltip.style("display", "none");
    }

    public move(x: number, y: number): void {
        this._tooltip
            .style("left", `${x}px`)
            .style("top", `${y}px`);
    }
}
